export enum GraphType {
	MODALITY_GRAPH = "modality_graph",
	EEG_MONTAGE = "EEG",
	IMAGE = "image",
}
